// TODO remove d3 dependency ?
import { get, set, update } from '../features/firebase.js'
import * as d3 from 'd3'
export default (app, { config }) => {
  const global = app.config.globalProperties
  window.d3 = d3
  global.window = window
  global.document = document
  global.localStorage = localStorage
  global.sessionStorage = sessionStorage
  window.$ = global.$ = (selector, node = document) => node.querySelector(selector)
  window.$$ = global.$$ = (selector, node = document) => Array.from(node.querySelectorAll(selector))
  window.browser = (ua = navigator.userAgent) => {
    if (/MSIE/.test(ua) || /Trident/.test(ua)) return 'ie'
    if (/Edge/.test(ua)) return 'edge'
    if (/Firefox/.test(ua)) return 'firefox'
    if (/Opera/.test(ua)) return 'opera'
    if (/Chrome/.test(ua)) return 'chrome'
    if (/Safari/.test(ua)) return 'safari'
    return 'unknown'
  }

  // TODO REMOVE
  window.update_domain = global.update_domain = domain => {
    if (!domain || !domain.length) return window.update_query({ domain: null })
    if (domain.length === 1) domain = [domain[0], domain[0]]
    const d = domain.__.map(d => d && new Date(d).format())
    if ($root.xs && $root.screen && $root.screen.datasets && $root.xs[$root.screen.datasets[0]][0]) {
      const dates = $root.xs[$root.screen.datasets[0]][0].dates.__.keys()
      d[0] = dates.__.find(k => k >= d[0]) || dates.last()
      d[1] = dates.__.find(k => k >= d[1]) || dates.last()
    }
    return window.update_query({ domain: d.unique().sort().join('|') })
  }
  window.log = global.log = console.log.bind(console)
  window.dbg = global.dbg = function () {
    console.log(arguments)
    debugger // eslint-disable-line
  }
  window.resize = global.resize = () => window.dispatchEvent(new Event('resize'))
  window.size = () => {
    let size = ''
    if (window.innerWidth > 1500) size += 'desktop4K '
    if (window.innerWidth > 1200) size += 'desktop '
    if (window.innerWidth > 900) size += 'laptop '
    if (window.innerWidth > 600) size += 'tablet '
    return (size += 'mobile')
  }
  function format(fmt) {
    // return d3.format(fmt)
    return x => {
      const formats = Object.assign({}, $root.config.formats) // || {}, $root.screen.formats || {})
      if (['fr', 'es', 'it'].includes($root.lang)) d3.formatDefaultLocale({ decimal: ',', thousands: ' ', grouping: [3] })
      // else d3.formatDefaultLocale({ decimal: '.', thousands: ',', grouping: [3] })
      if (!fmt) return x
      if (typeof x === 'string') {
        if (new Date(x) === 'Invalid Date') return x
        if (!formats[fmt]) return x
        return new Date(x).format(formats[fmt])
      }
      if (typeof fmt === 'function') return fmt(x)
      if (typeof fmt !== 'string') return x
      if (/\{([^}]*)\}/.test(fmt)) return fmt.replace(/\{([^}]*)\}/g, (m, a) => format(a)(x))
      if (x === 0 && !!formats.zero) fmt = fmt.replace(/\.[0-9]*/, '.0')
      if (x === null || x === undefined) return ''
      // if (x === 0) return x
      if (fmt === 'M') return d3.format(',')(Math.round((x * 100) / 1000000) / 100)
      if (fmt === 'M€') return format('M')(x) + 'M€'
      if (fmt === 'bp') return Math.round(x * 10000) + 'bp'
      if (fmt === '+bp') return x > 0 ? '+' + Math.round(x * 10000) + 'bp' : Math.round(x * 10000) + 'bp'
      if (fmt === 'd') return parseInt(x / (24 * 60 * 60000)) + 'd' + parseInt((x / 60000 - parseInt(x / (24 * 60 * 60000)) * 24 * 60) / 60) + 'h'
      if (fmt === 'pt') return d3.format('.2f')(x * 100)
      if (formats[fmt]) return format(formats[fmt])(x)
      const matchfmt = formats.__.__.findIndex((v, f) => RegExp(f).test(fmt))
      if (matchfmt) return format(formats[matchfmt])(x)

      try {
        let [match, f, currency = ''] = fmt
          .replace('USD', '$')
          .replace('EUR', '€')
          .replace('YEN', '¥')
          .replace('GBP', '£')
          .match(/([^$€£¥]*)([$€£¥])?/)
        if (f.slice(-3) === 'CHF') {
          f = f.replace('CHF', '')
          currency = 'CHF'
        }
        if (/s$/.test(f) && Math.abs(x) <= 1) f = f.replace('s', 'f')
        if (f.slice(-2) === 'fs') {
          const fixedPrecision = parseInt(f[1]) + 1
          return (
            d3
              .format('.10s')(x)
              .replace(/\.\d+/, m => m.slice(0, fixedPrecision))
              .replace('G', $root.lang === 'fr' ? 'Md' : 'Bn') + currency
          )
        }
        return (
          d3
            .format(f)(x)
            .replace(/^NaNk$/, 0)
            .replace('NaN', 0)
            .replace('G', $root.lang === 'fr' ? 'Md' : 'Bn') + currency
        )
      } catch (e) {
        return x
      }
    }
  }
  window.format = global.format = format
  window.unit = global.unit = str => {
    const matches = ('' + str).match(/^([\s\d.+-]+)(.*)$/)
    if (matches) return '<span class="number">{0}</span><span class="unit">{1}</span>'.format(matches.slice(1))
    return str
  }

  window.uquery = global.uquery = query => $root.$router.push({ query: Object.assign({}, $root.$route.query, query).__.filter(v => v || v === 0) })
  window.ufilter = global.ufilter = (k, v) => {
    const query = JSON.parse(JSON.stringify($root.$route.query || {}))
    query[k] = query[k] ? query[k].split('|') : []
    if (!v) return
    v.split('|').__.map(v => (query[k] = query[k].toggle(v)))
    query[k] = query[k].join('|')
    return uquery(query)
  }
  window.usearch = global.usearch = search => {
    const query = Object.fromEntries(
      (location.href.split('?')[1] || '')
        .split('&')
        .__.filter(d => d)
        .__.map(d => d.split('=')),
    ).__.map(decodeURIComponent)
    if (search === query.search) search = ''
    if (!search) delete query.search
    else query.search = search
    history.replaceState({}, null, location.href.split('?')[0] + query.__.reduce((acc, v, k) => `${acc}&${k}=${v}`, '?').replace('?&', '?'))
    dispatchEvent(new CustomEvent('search', { detail: search }))
  }
  window.update_query = global.update_query = uquery.throttle(400)
  window.update_filter = global.update_filter = ufilter.throttle(400)
  window.update_search = global.update_search = usearch.throttle(400)
  window.type = global.type = x => Object.prototype.toString.call(x).slice(8, -1).toLowerCase()

  // TODO: HACK add comment on why this hack and possibly what the ideal solution should be.
  window.top_bottom = (ds, len) => {
    const positive = ds.__.filter(d => d[1] >= 0).sort('-1')
    const negative = ds.__.filter(d => d[1] < 0).sort('1')
    return [['positive_key', 'positive_value', 'negative_key', 'negative_value']].concat(
      Array(len)
        .fill()
        .__.map((d, i) =>
          [positive[i] || ['', ''], negative[i] || ['', '']].__.filter(d => d)
            .__.map(d => [d[0], d[1]])
            .flat(Infinity),
        ),
    )
  }

  // TODO consider moving analytics logic to a dedicated module
  window._analytics = key => {
    const [fn, period, metric, arg1, arg2] = key.split('.')
    if (metric === 'diff') return analytics(key.replace('diff', 'fund')) - analytics(key.replace('diff', 'benchmark')) || '-'
    if (!$root.dates || !$root.dates.length || !$root.domain[1]) return '-'
    const domain = (period => {
      const first_date = new Date($root.dates.first())
      const last_date = new Date($root.domain[1])
      if (period === 'ytd') return [last_date.minus('1 year').end('year'), last_date]
      if (period === 'mtd') return [last_date.minus('1 month').end('month'), last_date]
      if (period === '1m') return [last_date.minus('1 month').end('month'), last_date]
      if (period === '3m') return [last_date.minus('3 month').end('month'), last_date]
      if (period === '6m') return [last_date.minus('6 month').end('month'), last_date]
      if (period === '1y') return [last_date.minus('1 year').end('month'), last_date]
      if (period === '3y') return [last_date.minus('3 years').end('month'), last_date]
      if (period === '5y') return [last_date.minus('5 years').end('month'), last_date]
      if (period.startsWith('years-'))
        return [
          new Date((last_date.getFullYear() - period.split('-')[1]).toString()).minus('year').end('year'),
          new Date((last_date.getFullYear() - period.split('-')[1] + 1).toString()).minus('year').end('year'),
        ]
      if (period === 'inception') return [first_date, last_date]
      if (period === 'domain') return [new Date($root.domain[0]), last_date]
    })(period)
    const dates = $root.x.performance.dates
    if (new Date(domain[0]) < new Date(dates.__.keys().first())) return '-'
    const d0 = domain[0].format()
    const d1 = domain[1].format()
    const before_d0 =
      dates[
        dates.__.keys()
          .reverse()
          .__.find(k => k <= d0)
      ]
    const after_d1 = dates[dates.__.keys().__.find(k => k > d1)]
    // For some indicators, I need before before_d0 to compute returns on 1y / 3y / 5y
    const x = ['var_X'].includes(fn) ? 1 : 0
    const data = $root.x.performance.slice(before_d0 - x, after_d1)
    if (['performance', 'performance_annualized', 'performance_weekly', 'volatility', 'max_drawdown_value'].includes(fn)) return data[fn](metric, period)
    if (['tracking_error', 'information_ratio', 'sharpe_ratio', 'alpha', 'beta'].includes(fn)) {
      if (metric) return data[fn](period, metric)
      return data[fn](period)
    }
    if (['var_X'].includes(fn)) return data[fn](metric, period, arg1)
    if (['var_X_Y_days'].includes(fn)) return data[fn](metric, period, arg1, arg2)
  }
  // window.__analytics = _analytics.memoize()
  // TODO docunent analytics interpretation
  window.analytics = global.analytics = _analytics
  window.unit = global.unit = str => {
    const matches = ('' + str).match(/^([\s\d.+-]+)(.*)$/)
    if (matches) return '<span class="number">{0}</span><span class="unit">{1}</span>'.format(matches.slice(1))
    return str
  }
  window.format_asof = asof => {
    if (/[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(asof)) return new Date(asof).format('YYYYMMDD')
    if (/[0-9]{4}-[0-9]{2}/.test(asof)) return new Date(asof).end('month').format('YYYYMMDD')
    if (/[0-9]{4}/.test(asof) && asof.length === 4) return new Date(asof).end('year').format('YYYYMMDD')
    return new Date().format('YYYYMMDD')
  }

  window.inject = async x => {
    if (!x || !x.length || $(x.includes('.css') ? `[href="${x}"]` : `[src="${x}"]`)) return
    if (Array.isArray(x))
      return Promise.all(x.__.filter(url => !Array.isArray(url)).__.map(inject)).then(() => inject(x.__.filter(url => Array.isArray(url)).flat(1)))
    return new Promise((resolve, reject) => {
      const el = document.createElement(x.includes('.css') ? 'link' : 'script')
      if (x.includes('.css')) el.rel = 'stylesheet'
      el[x.includes('.css') ? 'href' : 'src'] = x
      el.onload = resolve
      el.onerror = reject
      document.head.appendChild(el)
    })
  }
  window.idb = {
    db: new Promise((resolve, reject) => {
      const openreq = indexedDB.open('kvs', 1)
      openreq.onerror = () => reject(openreq.error)
      openreq.onsuccess = () => resolve(openreq.result)
      openreq.onupgradeneeded = () => openreq.result.createObjectStore('kv')
    }).then(db => {
      db.onversionchange = () => db.close()
      return db
    }),
    transaction(type, fn) {
      return this.db
        .then(
          db =>
            new Promise((resolve, reject) => {
              const transaction = db.transaction('kv', type)
              transaction.oncomplete = () => resolve(request)
              transaction.onabort = transaction.onerror = () => reject(transaction.error)
              const request = fn(transaction.objectStore('kv'))
            }),
        )
        .then(req => req.result)
    },
    get(key) {
      return this.transaction('readonly', store => store.get(key))
    },
    set(key, value) {
      return this.transaction('readwrite', store => store.put(value, key))
    },
    del(key) {
      return this.transaction('readwrite', store => store.delete(key))
    },
    clear() {
      return this.transaction('readwrite', store => store.clear())
    },
    keys() {
      // store.getAllKeys()
      const keys = []
      return this.transaction(
        'readonly',
        store =>
          ((store.openKeyCursor || store.openCursor).call(store).onsuccess = function () {
            if (!this.result) return
            keys.push(this.result.key)
            this.result.continue()
          }),
      ).then(() => keys)
    },
  }

  window.get = global.get = get
  window.set = global.set = set
  window.update = global.update = update
}
